import { Link } from "react-router-dom";
import { Mail, FileText, Info, DollarSign, Home, Shield, Linkedin } from "lucide-react";

const PAGE_LINKS = [
  { label: "Terms",   to: "/terms",   icon: FileText },
  { label: "Privacy", to: "/privacy", icon: Shield },
];

const SOCIAL_LINKS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/easyreports", icon: Linkedin },
  // future: { label: "YouTube", href: "https://www.youtube.com/...", icon: Youtube },
];

export function Footer() {
  return (
    <footer className="bg-brand-900 text-white/65 pt-14 px-8 pb-0">
      <div className="max-w-[1100px] mx-auto grid grid-cols-[2fr_1fr_1fr] gap-12 pb-12 border-b border-white/[0.08] max-[720px]:grid-cols-1 max-[720px]:gap-8">

        <div>
          <span className="block font-display text-[1.125rem] text-white mb-3">EasyReports</span>
          <p className="text-sm leading-relaxed text-white/45 m-0 max-w-[280px]">
            Making Report Cards should be EASY.
          </p>

          
        </div>

        <div>
          <span className="block text-[0.6875rem] font-bold tracking-[0.09em] uppercase text-white/35 mb-4">Legal</span>
          <ul className="list-none p-0 m-0 flex flex-col gap-[0.6rem]">
            {PAGE_LINKS.map(({ label, to, icon: Icon }) => (
              <li key={to}>
                <Link to={to} className="inline-flex items-center gap-2 text-sm text-white/60 no-underline transition-colors hover:text-white">
                  <Icon size={14} />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <span className="block text-[0.6875rem] font-bold tracking-[0.09em] uppercase text-white/35 mb-4">Contact</span>
          <ul className="list-none p-0 m-0 flex flex-col gap-[0.6rem]">
            <li>
              <a
                href="mailto:contact@easyreports.ca"
                className="inline-flex items-center gap-2 text-sm text-white/60 no-underline transition-colors hover:text-white"
              >
                <Mail size={14} />
                contact (at) easyreports (dot) ca
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto py-6 flex items-center justify-between gap-4 max-[720px]:flex-col max-[720px]:items-start max-[720px]:gap-4">
        <p className="text-[0.8rem] text-white/30 m-0">&copy; 2025–2026 EasyReports. All rights reserved.</p>
        <ul className="list-none p-0 m-0 flex items-center gap-2">
          {SOCIAL_LINKS.map(({ label, href, icon: Icon }) => (
            <li key={href}>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/[0.06] text-white/60 transition-colors hover:bg-white/10 hover:text-white"
              >
                <Icon size={16} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
